module.exports = __webpack_public_path__ + "img/logo_white.1301254d.png";